module.exports = __webpack_public_path__ + "media/male_resultB.a179c55f.mp3";